var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { QuestionPart } from '../QuestionPart';
import { object, primitive, withDefault } from '../../../utils/serializr/serializr';
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
export class QuestionStore {
    parent;
    /* @observable.ref */ questionPart;
    stopRecognitionWhileSpeak;
    // @editable() stageOuterHtml: string = '';
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    static get serializeInfo() {
        return {
            props: {
                questionPart: withDefault(object(QuestionPart, { parentDepth: 2 }), {}),
                // legacyAudios: disgardOldValue(json()),
                stopRecognitionWhileSpeak: withDefault(primitive, false),
                // stageOuterHtml: true
            },
        };
    }
}
__decorate([
    editable()
], QuestionStore.prototype, "stopRecognitionWhileSpeak", void 0);
__decorate([
    memoize
], QuestionStore, "serializeInfo", null);
